import React from 'react';
import { useParams } from 'react-router-dom';
import LayoutSistemaActsis from './features/actsis/LayoutSistemaActsis';
import Proximamente from './Proximamente';

function VistaSistemaRouter() {
    // Obtenemos el ID del sistema desde la URL
    const { sistemaId } = useParams();

    // Comparamos el ID. ¡Importante! useParams devuelve un string,
    // así que lo comparamos con '1' y no con 1.
    if (sistemaId === '1') {
        // Si es el sistema 1, renderizamos el Layout de ACTSIS
        return <LayoutSistemaActsis />;
    } else {
        // Para cualquier otro ID, renderizamos la página de "Próximamente"
        return <Proximamente />;
    }
}

export default VistaSistemaRouter;